import { render, staticRenderFns } from "./sureAAllocation.vue?vue&type=template&id=1e9b9361&scoped=true"
import script from "./sureAAllocation.vue?vue&type=script&lang=js"
export * from "./sureAAllocation.vue?vue&type=script&lang=js"
import style0 from "./sureAAllocation.vue?vue&type=style&index=0&id=1e9b9361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b9361",
  null
  
)

export default component.exports